export default "__VITE_ASSET__6784de0d__"